import { loadEMD } from './emd_data';
import { loadSalutation } from './portal_banner';
import { loadBadges } from './portal_notifications_badges';

export const initPortal = (): void => {
  loadEMD();
  loadSalutation();
  loadBadges();
};
